export default class EmailTemplates extends HTMLFormElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();
    }

    initEvents() {
        $('body').on('click', '.list-variables button', (e) => {
            const var_text = e.target.innerText;
            this.pasteHtmlAtCaret(var_text);
        });
    }

    // TODO: réécrire cette méthode de manière plus moderne...
    pasteHtmlAtCaret(html) {
        var sel, range;

        if (window.getSelection) {
            // IE9 and non-IE
            sel = window.getSelection();

            if (sel.getRangeAt && sel.rangeCount) {
                const input = sel.focusNode.firstElementChild || sel.focusNode; // Chrome vs Firefox

                // Display variable in any form input
                if (input.tagName === 'INPUT' && input.form != undefined && input.form && input.form === this) {
                    // Prevent logo from being displayed in subject field
                    if (input.name === 'object' && html.includes('LOGO_SITE')) {
                        return;
                    }

                    const position = input.selectionStart;
                    const new_value = [input.value.slice(0, position), html, input.value.slice(position)].join('');
                    input.value = new_value;
                    const new_caret_position = position + html.length;
                    input.focus();
                    input.setSelectionRange(new_caret_position, new_caret_position);
                }

                // Display variable in the template textarea
                else if (input.parentElement.offsetParent.className === "note-editing-area") {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    // Range.createContextualFragment() would be useful here but is
                    // non-standard and not supported in all browsers (IE9, for one)
                    var el = document.createElement("div");
                    el.innerHTML = html;
                    var frag = document.createDocumentFragment(), node, lastNode;
                    node = el.firstChild;
                    lastNode = frag.appendChild(node);
                    range.insertNode(frag);
                    // Preserve the selection
                    if (lastNode) {
                        range = range.cloneRange();
                        range.setStartAfter(lastNode);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                }
            }
        } else if (document.selection && document.selection.type != "Control") {
            // IE < 9
            document.selection.createRange().pasteHTML(html);
        }
    }
}
